/* Form object */
$.fn.Form = function()
{
	var _form = this;
	_form.adding = false;
	_form.element = _form.is("form.main-form") ? $(_form) : _form.find("form.main-form");
	_form.interface = {
		clear_button: _form.find(".btn-action-clear"),
		dropify_elements: []
	};

	/* Submit form */
	_form.submit_form = function()
	{
		// gather data
		var values = _form.element.serializeArray(),
		request = new FormData(),
		data = {};

		// build request
		var currentAction = '';
		var currentModel = $(_form.element[0]).data("model");
		request.append("model", currentModel);
		$.map(values, function(n, i){
			if (n['name'] == "action"){
				currentAction = n['value'];
				request.append("action", n['value']);
			} else if (n['name'] == "id"){
				request.append("id", n['value']);
			} else {
				if (data[n['name']] != undefined){
					if (typeof data[n['name']] != "array"){
						data[n['name']] = [data[n['name']]];
					}
					data[n['name']].push(n['value']);
				} else {
					data[n['name']] = n['value'];
				}
			}
		});

		// repeater field
		$('.repeater-field.main-form-field').each(function(){
			var repeaterField = $(this).data('repeater_field');
			data[repeaterField.data('name')] = repeaterField.val();
			repeaterField.names.forEach(function(name, index){
				delete data[name];
			});
		});

		// do not double-submit new
		if (_form.adding) {
			return false;
		} else if (currentAction == "add") {
			_form.adding = true;
			$('.btn-action-submit').prop('disabled', true);
			_form.element.find('button[type="submit"]').prop('disabled', true);
		}

		// force booleans
		if (currentModel == 'invoice') {
			if ($('input[name="exempt_tps"]').length && !$('input[name="exempt_tps"]').prop('checked')) {
				data.exempt_tps = 0;
			}
			if ($('input[name="exempt_tps"]').length && !$('input[name="exempt_tvq"]').prop('checked')) {
				data.exempt_tvq = 0;
			}
			if (!$('input[name="sartec"]').prop('checked')) {
				data.sartec = 0;
			}
			if (!$('input[name="sartec_tv"]').prop('checked')) {
				data.sartec_tv = 0;
			}
			if (!$('input[name="paid"]').prop('checked')) {
				data.paid = 0;
			}
		}

		// append data
		request.append("data", JSON.stringify(data));

		// add data
		$('input[type=file]').each(function(){
			if ($('input[type=file]').val()){
				request.append($(this).attr("name"), $(this)[0].files[0]);
			}
		});

		// add request to queue
		$.slr.db.add(request, _form.saved);
		return false;
	};

	/* Delete action */
	_form.delete = function()
	{
		// arrange form
		$("input[name=action]").val("delete");
		_form.submit_form();
	};

	/* Set field value */
	_form.set_attachment_value = function(field_name, field_value)
	{
		_form.find(":input[name=" + field_name + "_id]").val(field_value);
		_form.find(":input[name=" + field_name + "]").val("");
	};

	/* Lock form */
	_form.lock = function()
	{
		// _form.element.addClass("disabled");
	};

	/* Unlock form */
	_form.unlock = function()
	{
		_form.adding = false;
		$('.btn-action-submit').prop('disabled', false);
		_form.element.find('button[type="submit"]').prop('disabled', false);
	};

	/* Clear form */
	_form.clear = function()
	{
		_form.element.removeError();
		_form.find(".card-block").slideUp(350, function(){
			_form.element.each(function(){
				$(this).get(0).reset();
			});
			_form.unlock();
			_form.find("textarea").val("");
			_form.interface.dropify_elements.forEach(function(element){
				var dropify_element = element.data('dropify');
				dropify_element.resetPreview();
				dropify_element.clearElement();
			});
			_form.find("input[type=checkbox]").prop("checked", false).change();
			_form.find("select").val("").change();
			setTimeout(function(){
				_form.find(".card-block").slideDown(350);
			}, 100);
		});

		return false;
	}

	/* Form saved: overridden in specific forms */
	_form.saved = function()
	{
		// nothing on normal form
	}

	/* Init form */
	return function()
	{
		/* Initialize form submission */
		_form.element.on('submit', function(e){
			e.preventDefault();
			_form.submit_form();
		});

		/* Clear button action and notification */
		_form.interface.clear_button.on("click", function(){
			$.slr.notify({
				icon: 'fa fa-eraser',
				title: 'Formulaire réinitialisé',
				message: "Vous avez réinitialisé le contenu du formulaire."
			}, { type: 'warning' });
			_form.clear();
		});

		/* Masked fields */
		_form.find('input.masked').each(function(){
			$(this).mask($(this).data("mask"), {placeholder: $(this).attr("placeholder")});
		});

		/* Resizeable text area */
		autosize(_form.find('textarea'));

		/* Select */
		_form.find("select").
		not("#slr-element-template select, .template select").	// not an element template
		each(function(){
			if ($(this).hasClass("select2") || $(this).hasClass("select-search")){
				$(this).select2(select2WithCompany());
			} else if ($(this).hasClass("select-plus-new")){
				// managed inside Contract.js
			} else if ($(this).hasClass("select")){
				$(this).selectpicker({
					size: 5
				});
			}
		});

		/* Date time picker */
		_form.find('.date-picker').datetimepicker({
			widgetPositioning: {
				horizontal: 'right'
			},
			icons: {
				time: "fa fa-clock-o",
				date: "fa fa-calendar",
				up: "fa fa-arrow-up",
				down: "fa fa-arrow-down",
				previous: 'fa fa-arrow-left',
				next: 'fa fa-arrow-right'
			},
			format: 'DD/MM/YYYY',
			locale: 'fr-ca'
		});

		/* Bootstrap toggle */
		_form.find('input[type=checkbox]').not(".custom-control-input").bootstrapToggle();

		/* Repeater fields */
		_form.find('.repeater-field').each(function(){
			$(this).RepeaterField();
		});

		/* Form controls */
		$(".btn-action-submit").on("click", function(){
			if ($.slr.interface.form != undefined){
				$.slr.interface.form.find("button[type=submit]").click();
			}
		});
		$(".btn-action-clear").on("click", function(){
			if ($.slr.interface.form != undefined){
				$.slr.interface.form.clear();
			}
		});
		if ($('#ftp-module.panel').length) {
			$('.btn-open-ftp-panel').on('click', function() {
				if (!$('#ftp-module.panel').hasClass('panel--open')) {
					$('#ftp-module.panel').addClass('panel--open')
				} else {
					$('#ftp-module.panel').removeClass('panel--open')
				}
			})
		}

		/* Lock element on form cards */
		var lock_element = $('<div class="form-lock"></div>');
		lock_element.append($(".slr-loader:first").clone());
		_form.find(".card-block").each(function(){
			$(this).append(lock_element.clone());
		});

		// Specific forms
		if (_form.element.data("model") == "invoice"){
			_form.InvoiceForm();
		} else if (_form.element.data("model") == "contact"){
			_form.ContactForm();
		}

		// Init done
		return _form;
	}();
};

